require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./thinking-about-the-weekend-ahead.json") })
        }
      }, "path---thinking-about-the-weekend-ahead");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---thinking-about-the-weekend-ahead!./.cache/json/thinking-about-the-weekend-ahead.json
// module id = 574
// module chunks = 231608221292675